import { render, staticRenderFns } from "./VisionboardPreview.vue?vue&type=template&id=a76394d8&"
import script from "./VisionboardPreview.vue?vue&type=script&lang=js&"
export * from "./VisionboardPreview.vue?vue&type=script&lang=js&"
import style0 from "./VisionboardPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports